import { render } from "./MagazineSection.vue?vue&type=template&id=56f9f0a3&scoped=true"
import script from "./MagazineSection.vue?vue&type=script&lang=js"
export * from "./MagazineSection.vue?vue&type=script&lang=js"

import "./MagazineSection.vue?vue&type=style&index=0&id=56f9f0a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f9f0a3"]])

export default __exports__